"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_game__console(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "1030adb3-a530-40c9-818d-3025203ae2ab",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "59066366-f769-4692-936e-921221be0bc3",
    x1: -141.13,
    y1: -119.35,
    x2: 86.66,
    y2: 108.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cd0ce11c-f4bd-471e-ae5f-e1860aa0f07c",
    x1: 143.36,
    y1: 107.39,
    x2: 153.11,
    y2: 121.14,
    xlinkHref: "#59066366-f769-4692-936e-921221be0bc3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d8bafbb5-c1be-4156-acd1-b977591585c0",
    x1: 154.45,
    y1: 99.53,
    x2: 164.2,
    y2: 113.28,
    xlinkHref: "#59066366-f769-4692-936e-921221be0bc3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3d04c742-cfd7-43bf-815d-01ca801e97a7",
    x1: -69.15,
    y1: -104.52,
    x2: 151.92,
    y2: 116.56,
    xlinkHref: "#59066366-f769-4692-936e-921221be0bc3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "72a05179-0b6e-434a-8606-c4da06d1832d",
    x1: -58.25,
    y1: -115.42,
    x2: 162.82,
    y2: 105.66,
    xlinkHref: "#59066366-f769-4692-936e-921221be0bc3"
  })), /*#__PURE__*/React.createElement("title", null, "game-console-hi"), /*#__PURE__*/React.createElement("g", {
    id: "65426576-5315-47f2-bf71-24fa7cd59419",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "5c7e3f1d-e4e7-400b-8a36-6aa8482007fa",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96,126.15H59.78a6.34,6.34,0,0,0-5.93,4.2l-3.39,9.23A18.77,18.77,0,0,1,32.91,152h0A17.32,17.32,0,0,1,16,132.08l9.88-69.92A25.49,25.49,0,0,1,51,40h90.1a25.49,25.49,0,0,1,25.06,22.16L176,132.08A17.32,17.32,0,0,1,159.09,152h0a18.77,18.77,0,0,1-17.55-12.42l-3.39-9.23a6.34,6.34,0,0,0-5.93-4.2Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,132.09A17.25,17.25,0,0,1,159,150a18.74,18.74,0,0,1-17.51-12.41l-3.39-9.24a6.32,6.32,0,0,0-5.91-4.19H59.87A6.32,6.32,0,0,0,54,128.34l-3.39,9.24A18.72,18.72,0,0,1,33.06,150a17.25,17.25,0,0,1-17-17.9A17.32,17.32,0,0,0,32.93,152h0a18.77,18.77,0,0,0,17.55-12.41l3.39-9.24a6.34,6.34,0,0,1,5.93-4.19h72.45a6.34,6.34,0,0,1,5.92,4.19l3.39,9.24A18.78,18.78,0,0,0,159.11,152h0A17.3,17.3,0,0,0,176,132.09Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "61.95 83.81 58.81 81.3 42.35 87.24 42.35 87.83 78.72 123.97 95.95 123.97 125.89 123.97 65.33 64.25 61.95 83.81",
    fill: "url(#59066366-f769-4692-936e-921221be0bc3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,78.82H67v-11a5,5,0,0,0-10,0v11H46a5,5,0,0,0,0,10H57v11a5,5,0,0,0,10,0v-11H78a5,5,0,0,0,0-10Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,103.07a5,5,0,0,1-5-5v2.33a5,5,0,0,0,10,0V98.07A5,5,0,0,1,62,103.07Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,87.07a5,5,0,0,1-4.85-3.84A5,5,0,0,0,46,89.4H57V87.07Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,87.07H67V89.4H78a5,5,0,0,0,4.85-6.17A5,5,0,0,1,78,87.07Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176,132.14l-.24-1.66-41.7-40.84-1.05.8L122.47,80.06l-8.53,7.84v.59l58,57.62A17.63,17.63,0,0,0,176,132.14Z",
    transform: "translate(0 0)",
    opacity: 0.1,
    fill: "url(#cd0ce11c-f4bd-471e-ae5f-e1860aa0f07c)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.19 105.28 145.84 79.47 144.79 80.27 134.26 69.89 125.73 77.73 125.73 78.32 175.35 127.61 172.19 105.28",
    opacity: 0.1,
    fill: "url(#d8bafbb5-c1be-4156-acd1-b977591585c0)",
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.75,130.48l-41.7-40.84-1.05.8L122.47,80.06l-8.53,7.84v.59l58,57.62a17.63,17.63,0,0,0,4.05-14Z",
    transform: "translate(0 0)",
    fill: "url(#3d04c742-cfd7-43bf-815d-01ca801e97a7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.19 105.28 145.84 79.47 144.79 80.27 134.26 69.89 125.73 77.73 125.73 78.32 175.35 127.61 172.19 105.28",
    fill: "url(#72a05179-0b6e-434a-8606-c4da06d1832d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,74h0m0-6a6,6,0,1,0,6,6A6,6,0,0,0,130,68Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,78a6,6,0,0,1-5.91-5,6.64,6.64,0,0,0-.09,1,6,6,0,0,0,12,0,6.64,6.64,0,0,0-.09-1A6,6,0,0,1,130,78Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.91,84h0m0-6a6,6,0,1,0,6,6A6,6,0,0,0,141.91,78Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.91,88A6,6,0,0,1,136,83a6.64,6.64,0,0,0-.09,1,6,6,0,0,0,12,0,5.55,5.55,0,0,0-.09-1A6,6,0,0,1,141.91,88Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118,84h0m0-6a6,6,0,1,0,6,6A6,6,0,0,0,118,78Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118,88a6,6,0,0,1-5.91-5,6.64,6.64,0,0,0-.09,1,6,6,0,0,0,12,0,6.64,6.64,0,0,0-.09-1A6,6,0,0,1,118,88Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130,94h0m0-6a6,6,0,1,0,6,6A6,6,0,0,0,130,88Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,98a6,6,0,0,1-5.91-5,6.64,6.64,0,0,0-.09,1,6,6,0,0,0,12,0,6.64,6.64,0,0,0-.09-1A6,6,0,0,1,130,98Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88,56h0m0-4a4,4,0,1,0,4,4A4,4,0,0,0,88,52Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,58a4,4,0,0,1-3.86-3A4.09,4.09,0,0,0,84,56a4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,88,58Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,56h0m0-4a4,4,0,1,0,4,4A4,4,0,0,0,104,52Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,58a4,4,0,0,1-3.86-3,4.09,4.09,0,0,0-.14,1,4,4,0,0,0,8,0,4.09,4.09,0,0,0-.14-1A4,4,0,0,1,104,58Z",
    transform: "translate(0 0)",
    fill: "#333"
  }));
}

var _default = ic_game__console;
exports.default = _default;